import React from "react";
import { Regular3Style } from "./css/Regular3Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const regular_1_3 = (props) => {
  return (
    <Regular3Style>
      <div className="template-wrapper">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="t3-containerThree d-flex">
          <div className="t3-t-colmn t3-t-colmn-2">
            <div className="t3-img-wrapper t3-woman">
              <TemplateImage slideType={props.slideType} file={props.file} />
            </div>
          </div>
          <div className="t3-t-colmn t3-t-colmn-1">
            <div className="t3-text-wrappers">
              <TemplateText
                id={props.id}
                text={props.text}
                textStyle={props.textStyle}
                editStatus={props.editStatus}
                onInputSlideText={props.onInputSlideText}
              />
            </div>
          </div>
        </div>
      </div>
    </Regular3Style>
  );
};

export default regular_1_3;
